import React, { useEffect, useState } from "react";
import NavigationBar from "../NavigationBar";
import SideNavigation from "../SideNavigation";
import micro_reporter_api from "../../apis/micro-reporter-api";
import "../../styles/css/UserList.css";
import { Alert, Button, Card, Form, Row, Col } from "react-bootstrap";
import $ from "jquery";
import noReport from "../../assets/img/no-report.png";
import Utils from "../../libraries/utils";
import { useHistory } from "react-router-dom";

const UserReportPermissions = () => {
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  let errorMessage = "An unexpected error was encountered!";
  let history = useHistory();
  const [reports, setReports] = useState([]);
  const [userReports, setUserReports] = useState([]);

  let id = new URLSearchParams(window.location.search).get("id");
  let name = new URLSearchParams(window.location.search).get("name");

  // window.onload = function(){
  //     checkUserReports();
  // }

  // document.addEventListener("DOMContentLoaded", function() {
  //     checkUserReports();
  // });

  $(document).ready(function () {
    checkUserReports();
  });

  useEffect(() => {
    getReports();
  }, []);

  const getReports = () => {
    (async () => {
      try {
        Utils.loadingScreen("show");
        await micro_reporter_api
          .get(`/micro-reporter/report/all-reports`)
          .then((response) => {
            setReports(
              response.data.sort(function (x, y) {
                return x.reportUsers.some((item) => item.user.id == id)
                  ? -1
                  : y.reportUsers.some((item) => item.user.id == id)
                  ? 1
                  : 0;
              })
            );
            getUserReports(id);
            Utils.loadingScreen("hide");
          });
      } catch (e) {
        Utils.loadingScreen("hide");
        setShowErrorMessage(true);
      }
    })();
  };

  const getUserReports = (id) => {
    (async () => {
      try {
        Utils.loadingScreen("show");
        await micro_reporter_api
          .get(`/micro-reporter/user/get-user-reports?id=${id}`)
          .then((response) => {
            setUserReports(response.data);
            Utils.loadingScreen("hide");
          });
      } catch (e) {
        Utils.loadingScreen("hide");
        setShowErrorMessage(true);
      }
    })();
  };

  const getUpdatedReports = () => {
    let list = [];
    reports.map((report) => {
      if (document.getElementById(report.id + "-canView").checked) {
        let o = {
          user: { id: id },
          report: {
            id: report.id,
            name: report.name,
            source: report.source,
            creationDate: report.creationDate,
            databaseConnection: { id: report.databaseConnection.id },
            status: true,
          },
          canView: document.getElementById(report.id + "-canView").checked,
          canExport: document.getElementById(report.id + "-canExport").checked,
        };
        list.push(o);
      }
    });
    return list;
  };

  const saveUserReports = () => {
    (async () => {
      let list = getUpdatedReports();
      let dto = { id: id, reportUserList: list };
      try {
        Utils.loadingScreen("show");
        let user = JSON.parse(localStorage.getItem("user"));
        let headers = {
          userId: user.id,
          username: user.username,
          relatedName: encodeURIComponent(name).substring(0, 100),
          relatedId: id,
        };
        const config = { headers };
        await micro_reporter_api
          .post("/micro-reporter/user/update-user-reports", dto, config)
          .then((response) => {
            history.push("/users");

            Utils.loadingScreen("hide");
          });
      } catch (err) {
        Utils.loadingScreen("hide");
        try {
          setShowErrorMessage(true);
        } catch (err) {
          setShowErrorMessage(true);
        }
      }
    })();
  };

  const checkUserReports = () => {
    if (reports.length > 0 && userReports.length > 0) {
      userReports.map((userReport) => {
        if (
          userReport.can_view &&
          document.getElementById(userReport.report_id + "-canView")
        ) {
          document.getElementById(
            userReport.report_id + "-canView"
          ).checked = true;
        }
        if (
          userReport.can_export &&
          document.getElementById(userReport.report_id + "-canExport")
        ) {
          document.getElementById(
            userReport.report_id + "-canExport"
          ).checked = true;
        }
      });
    }
  };

  const toggleCheckboxView = (id) => {
    if (document.getElementById(id + "-canView")) {
      document.getElementById(id + "-canExport").checked = false;
    }
  };

  const toggleCheckboxExport = (id) => {
    if (!document.getElementById(id + "-canView").checked) {
      document.getElementById(id + "-canExport").checked = false;
    }
  };

  // const searchReport = () => {
  //     if (document.getElementById("searchReport")){
  //         let value = document.getElementById("searchReport").value.toLowerCase();
  //         $(".reportTable tr").filter(function() {
  //             $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
  //         });
  //     }
  // };

  const renderReportTable = () => {
    if (reports.length > 0) {
      return (
        <div>
          <Row xs={1} md={3} className="g-4">
            {renderList(reports)}
          </Row>
          <Button
            type="submit"
            style={{ float: "right", width: "170px" }}
            onClick={() => saveUserReports()}
          >
            Save
          </Button>
        </div>
      );
    } else if (reports.length === 0) {
      return (
        <div id="user-not-found-div">
          <div id="user-list-center-div">
            <img
              src={noReport}
              style={{ width: "100px" }}
              alt="No user found."
            />
            <br />
            <span>No report found!</span>
          </div>
        </div>
      );
    }
  };

  const renderList = (reports) => {
    return reports.map((report) => {
      return (
        <Col>
          <Card bg="light" className="mb-4" style={{ overflow: "hidden" }}>
            <Card.Body style={{ paddingBottom: "0" }}>
              <Card.Title
                title={report.name}
                style={{ fontSize: "15px", display: "block ruby" }}
              >
                {report.name}
              </Card.Title>
              <Form.Row style={{ paddingLeft: "5px" }}>
                <Form.Group
                  id="formGridCheckbox"
                  style={{ marginRight: "25px" }}
                >
                  <Form.Check
                    type="checkbox"
                    id={report.id + "-canView"}
                    label="can view"
                    custom
                    onClick={() => toggleCheckboxView(report.id)}
                  />
                </Form.Group>
                <Form.Group id="formGridCheckbox">
                  <Form.Check
                    type="checkbox"
                    id={report.id + "-canExport"}
                    label="can export"
                    custom
                    onClick={() => toggleCheckboxExport(report.id)}
                  />
                </Form.Group>
              </Form.Row>
            </Card.Body>
          </Card>
        </Col>
      );
    });
  };

  return (
    <div>
      <SideNavigation current="users" />
      <div className="page-order">
        <NavigationBar />
        <div id="user-report-permission-div">
          <div id="user-report-permission-panel">
            <h5 className="page-title" style={{ marginBottom: "40px" }}>
              User Report Permissions
            </h5>
            {showErrorMessage ? (
              <Alert variant="danger">{errorMessage}</Alert>
            ) : null}
            {renderReportTable()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserReportPermissions;
